/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.SheetGoogleConfiguration = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The SheetGoogleConfiguration model module.
   * @module model/SheetGoogleConfiguration
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>SheetGoogleConfiguration</code>.
   * @alias module:model/SheetGoogleConfiguration
   * @class
   */
  var exports = function() {
    var _this = this;













  };

  /**
   * Constructs a <code>SheetGoogleConfiguration</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SheetGoogleConfiguration} obj Optional instance to populate.
   * @return {module:model/SheetGoogleConfiguration} The populated <code>SheetGoogleConfiguration</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('SpreadsheetName')) {
        obj['SpreadsheetName'] = ApiClient.convertToType(data['SpreadsheetName'], 'String');
      }
      if (data.hasOwnProperty('SpreadsheetID')) {
        obj['SpreadsheetID'] = ApiClient.convertToType(data['SpreadsheetID'], 'String');
      }
      if (data.hasOwnProperty('GoogleOAuthUserID')) {
        obj['GoogleOAuthUserID'] = ApiClient.convertToType(data['GoogleOAuthUserID'], 'Integer');
      }
      if (data.hasOwnProperty('ForecastTemplateSourceIdentifier')) {
        obj['ForecastTemplateSourceIdentifier'] = ApiClient.convertToType(data['ForecastTemplateSourceIdentifier'], 'String');
      }
      if (data.hasOwnProperty('IsGeneratedSheet')) {
        obj['IsGeneratedSheet'] = ApiClient.convertToType(data['IsGeneratedSheet'], 'Boolean');
      }
      if (data.hasOwnProperty('FileWatchID')) {
        obj['FileWatchID'] = ApiClient.convertToType(data['FileWatchID'], 'String');
      }
      if (data.hasOwnProperty('IsRolling')) {
        obj['IsRolling'] = ApiClient.convertToType(data['IsRolling'], 'Boolean');
      }
      if (data.hasOwnProperty('SendReminder')) {
        obj['SendReminder'] = ApiClient.convertToType(data['SendReminder'], 'Boolean');
      }
      if (data.hasOwnProperty('RemindedUserID')) {
        obj['RemindedUserID'] = ApiClient.convertToType(data['RemindedUserID'], 'Integer');
      }
      if (data.hasOwnProperty('ReminderPeriodTypeID')) {
        obj['ReminderPeriodTypeID'] = ApiClient.convertToType(data['ReminderPeriodTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('IsTemplate')) {
        obj['IsTemplate'] = ApiClient.convertToType(data['IsTemplate'], 'Boolean');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} SpreadsheetName
   * @default ''
   */
  exports.prototype['SpreadsheetName'] = '';
  /**
   * @member {String} SpreadsheetID
   * @default ''
   */
  exports.prototype['SpreadsheetID'] = '';
  /**
   * @member {Integer} GoogleOAuthUserID
   */
  exports.prototype['GoogleOAuthUserID'] = undefined;
  /**
   * @member {String} ForecastTemplateSourceIdentifier
   * @default ''
   */
  exports.prototype['ForecastTemplateSourceIdentifier'] = '';
  /**
   * @member {Boolean} IsGeneratedSheet
   * @default false
   */
  exports.prototype['IsGeneratedSheet'] = false;
  /**
   * @member {String} FileWatchID
   * @default ''
   */
  exports.prototype['FileWatchID'] = '';
  /**
   * @member {Boolean} IsRolling
   * @default false
   */
  exports.prototype['IsRolling'] = false;
  /**
   * @member {Boolean} SendReminder
   * @default false
   */
  exports.prototype['SendReminder'] = false;
  /**
   * @member {Integer} RemindedUserID
   */
  exports.prototype['RemindedUserID'] = undefined;
  /**
   * @member {Integer} ReminderPeriodTypeID
   */
  exports.prototype['ReminderPeriodTypeID'] = undefined;
  /**
   * @member {Boolean} IsTemplate
   * @default false
   */
  exports.prototype['IsTemplate'] = false;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


